//import { AuthContext } from "../../../context/AuthContext"
import { useContext } from "react"
import { AuthContext } from "../context/AuthContext"

/**
 * Returns the current user and authentication methods from the AuthContext.
 * Must be used inside an AuthContextProvider.
 * #core #context
 * @returns {user: User, login: Function, logout: Function, updatePassword: Function}
 * @throws If useAuthContext is called outside of an AuthContextProvider
 */
export const useAuthContext = () => {
  const context = useContext(AuthContext)

  if(!context) {
    throw Error('useAuthContext must be used inside an AuthContextProvider')
  }

  return context
}